<template>
  <b-modal
    id="pasteDirectionFromExcelModal"
    size="lg"
    title="Добавление направлений из Excel"
    @ok="onSave"
    @show="updateData"
  >
    <b-form-group label="Строка из Excel">
      <b-form-textarea rows="5" v-model="rowText" />
    </b-form-group>
    <b-alert show variant="danger" v-if="isIncorrectFormat && rowText">
      Неверный формат ввода
    </b-alert>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button @click="ok" variant="primary" :disabled="isIncorrectFormat">
        Добавить
      </b-button>
      <b-button @click="cancel" variant="outline-primary">
        Отмена
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import statisticsApi from '@/api/statistics'

export default {
  name: 'PasteFromExcelDirectionModal',
  data() {
    return {
      rowText: '',
      currentYear: 0
    }
  },
  async created() {
    this.currentYear = Number((await statisticsApi.getStatisticYear()).data.year)
  },
  computed: {
    isIncorrectFormat() {
      const splittedData = this.splitOnRows(this.rowText)
      if (splittedData.length !== 3) {
        return true
      }
      return splittedData[0].split('\t').length !== 14
        || splittedData[1].split('\t').length !== 4
        || splittedData[2].split('\t').length !== 4
    }
  },
  methods: {
    onSave() {
      this.$emit('paste', this.parseData(this.rowText))
    },
    updateData() {
      this.rowText = ''
    },
    splitOnRows(data) {
      const noLineBreaks = data.replaceAll('\n', '')
      return noLineBreaks.split('\t\t\t\t\t\t\t\t\t\t')
    },
    parseData(data) {
      const splitWithEge = this.splitOnRows(data)
      const firstRow = splitWithEge[0].split('\t')
      const secondRow = splitWithEge[1].split('\t')
      const thirdRow = splitWithEge[2].split('\t')
      const olympiad = firstRow[10].split(',').map((ol) => ({
        title: ol.replace(/\(\+?\d+\)/g, '').trim(),
        mark: (ol.match(/\d+/g) || []).pop()
      }))
      return {
        code: firstRow[0],
        budget: {
          egeSubjects: [
            {
              name: firstRow[11],
              order: 1,
              minimalMark: firstRow[12] || 0
            },
            {
              name: secondRow[1],
              order: 2,
              minimalMark: secondRow[2] || 0
            },
            {
              name: thirdRow[1],
              order: 3,
              minimalMark: thirdRow[2] || 0
            }
          ],
          directionMarkHistories: [
            {
              year: this.currentYear,
              quota: firstRow[2] || null,
              mark: null
            },
            {
              year: this.currentYear - 1,
              quota: null,
              mark: firstRow[4] || null
            }
          ]
        },
        contract: {
          egeSubjects: [
            {
              name: firstRow[13],
              order: 1,
              minimalMark: firstRow[12] || 0
            },
            {
              name: secondRow[3],
              order: 2,
              minimalMark: secondRow[2] || 0
            },
            {
              name: thirdRow[3],
              order: 3,
              minimalMark: thirdRow[2] || 0
            }
          ],
          directionMarkHistories: [
            {
              year: this.currentYear,
              quota: firstRow[3] || null,
              mark: null
            },
            {
              year: this.currentYear - 1,
              quota: null,
              mark: firstRow[5] || null
            }
          ]
        },
        target: {
          egeSubjects: [
            {
              name: firstRow[11],
              order: 1,
              minimalMark: firstRow[12] || 0
            },
            {
              name: secondRow[1],
              order: 2,
              minimalMark: secondRow[2] || 0
            },
            {
              name: thirdRow[1],
              order: 3,
              minimalMark: thirdRow[2] || 0
            }
          ],
          directionMarkHistories: [
            {
              year: this.currentYear,
              quota: firstRow[7] || null,
              mark: firstRow[9] || null
            },
            {
              year: this.currentYear - 1,
              quota: firstRow[6] || null,
              mark: firstRow[8] || null
            }
          ]
        },
        olympiad: olympiad.filter((o) => o.title && o.mark)
      }
    }
  }
}
</script>

<style scoped>

</style>
